














































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import { AxiosStatic } from "axios";
import IResource from "@/interfaces/IResource";
import draggable from 'vuedraggable'
import IResourceimage from '@/interfaces/IResourceimage';

@Component({
	components: {
		draggable
	}
})
export default class SettingsResourceimages extends Vue {

	public $http!: AxiosStatic;

	public $refs!: {
		uploader: HTMLInputElement;
	};

	@Prop({
		required: true,
		type: Number
	})
	public resourceid!: number;

	public resourceimages: IResourceimage[] | null = null;

	public showError: boolean = false;
	public isLoading: boolean = false;
	public isSorting: boolean = false;
	public isUploading: boolean = false;
	public showInvalidFileExtension: boolean = false;
	public showInvalidFileSize: boolean = false;

	get resource(): IResource | null {
		if (this.$store.state.resources) {
			let filtered = this.$store.state.resources.filter((r: IResource) => r.id == this.resourceid);
			if (filtered.length > 0) {
				return filtered[0];
			}
		}
		return null;
	}

	get storeResourceimages(): IResourceimage[] | null {
		if (this.resource) {
			return this.resource.resourceimages;
		}
		return null;
	}

	@Watch('storeResourceimages', { immediate: true })
	public watchStoreResourceimages() {
		if (this.storeResourceimages) {
			this.resourceimages = [...this.storeResourceimages].sort((a: IResourceimage, b: IResourceimage) => a.order - b.order);
		} else {
			this.resourceimages = null;
		}
	}

	public mounted() {
		this.showError = false;
		this.isLoading = false;

		this.$store.dispatch('loadOrganisation', {root: true});
	}

	public checkImage(): void {

		// abort if already uploading
		if (this.isUploading) {
			return;
		}

		if (this.$refs.uploader && this.$refs.uploader.files && this.$refs.uploader.files.length > 0) {

			this.isUploading = true;
			this.showError = false;
			this.showInvalidFileExtension = false;
			this.showInvalidFileSize = false;

			let allowedExtensions = ['jpeg', 'png', 'jpg', 'gif'];

			let fileName: string = this.$refs.uploader.files[0].name.toLowerCase();
			let fileExt = fileName.substr(fileName.lastIndexOf('.') + 1);
			if (allowedExtensions.includes(fileExt)) {
				let reader: FileReader = new FileReader();
				reader.onload = async (e: any) => {
					try {
						let contents: string = e.target.result;
						if (contents.length > 1024 * 1024 * 10) {
							this.showInvalidFileSize = true;
						} else {
							await this.uploadImage();
						}
						this.isUploading = false;
					} catch (e) {
						this.showError = true;
						this.isUploading = false;
					}
				};
				reader.readAsBinaryString(this.$refs.uploader.files[0]);
				reader.onerror = () => {
					this.showError = true;
					this.isUploading = false;
				};
			} else {
				this.showInvalidFileExtension = true;
				this.isUploading = false;
			}
		}
	}

	public async uploadImage(): Promise<void> {
		if (this.resource) {
			let formData = new FormData();
			if (this.$refs.uploader && this.$refs.uploader.files && this.$refs.uploader.files.length > 0) {
				formData.append('image', this.$refs.uploader.files[0])
			}

			await this.$http.post(
				`/private/resource/${this.resource.id}/resourceimage`,
				formData,
				{
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
			)
			this.$store.dispatch('loadResources', {root: true});
			this.$refs.uploader.value = '';
		}
	}

	public deleteImage(image: IResourceimage) {
		if (confirm('Dieses Bild wirklich löschen?')) {
			this.isLoading = true;
			this.$http.delete('/private/resourceimage/' + image.id).then(() => {
				this.isLoading = false;
				this.$store.dispatch('loadResources', {root: true});
			}).catch(() => {
				this.isLoading = false;
				this.showError = true;
			});
		}
	}

	public onListChange() {
		if (this.resourceimages) {
			this.isSorting = true;
			let ids = this.resourceimages.map((field: IResourceimage) => field.id);
			this.$http.post('/private/resource/' + this.resourceid + '/resourceimages/sort', { order: ids }).then(() => {
				this.$store.dispatch('loadResources', {root: true}).finally(() => {
					this.isSorting = false;
				});
			}).catch(() => {
				this.isSorting = false;
			});
		}
	}


}
